<intello-dialog-header [title]="data.title " (emitCloseClick)="dialogRef.close(null)">
</intello-dialog-header>

<intello-dialog-content class="dialog-content"
  [class.override-max-height]="!IsNullOrUndefinedOrEmpty(data.contentMaxHeight)"
  [style.maxHeight]="!IsNullOrUndefinedOrEmpty(data.contentMaxHeight) ? data.contentMaxHeight : 'initial'">

  <ng-template kbDialogContentHost></ng-template>

  <ng-container [ngSwitch]="mode">
    <ng-container *ngSwitchCase="'Text'">
      <div class="text-content" [innerHTML]="data.text | safe:'html'"></div>
    </ng-container>
  </ng-container>

</intello-dialog-content>

<intello-dialog-footer>

  <div class="flex flex-row">
    <intello-buttons-default class="flex-initial" (onClick)="dialogRef.close(null)">{{'General.Cancel' | translate}}
    </intello-buttons-default>
    <ng-container *ngIf="mode === 'Text'">
      <intello-buttons-submit class="ml-1 flex-initial" (onClick)="dialogRef.close(true)">{{'General.Confirm' | translate}}
      </intello-buttons-submit>
    </ng-container>
  </div>
</intello-dialog-footer>